export enum MOVE_TYPE {
  CONTRACT_OTHER_TENANT = 'CONTRACT_OTHER_TENANT',
  CONTRACT_SAME_TENANT = 'CONTRACT_SAME_TENANT',
  CONTRACT_END = 'CONTRACT_END',
  CONTRACT_IGNORE = 'CONTRACT_IGNORE',
  CONTRACT_START = 'CONTRACT_START'
}
